import axios from "axios";

import { BASEURL } from "../../constants/const";
import { encryptStorage } from "../../constants/EncryptStorage";

export function ApiEvent() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: BASEURL,
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
  const fileAuthAxios = axios.create({
    baseURL: BASEURL,
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
    responseType: "arraybuffer",
  });

  const url = BASEURL + "event/";
  return {
    delete: (id, updateAllEvent) =>
      authAxios.delete(url + "delete/" + id + "/" + updateAllEvent),
    get: (searchEventModel) =>
      authAxios.post(url + "getList/", searchEventModel),
    getEventsReport: (searchEventModel) =>
      authAxios.post(url + "getEventsReport/", searchEventModel),
    getEventsReportWithNoAttendance: (searchEventModel) =>
      authAxios.post(
        url + "getEventsReportWithNoAttendance/",
        searchEventModel
      ),
    getEventParticipants: (searchEventParticipants) =>
      authAxios.post(url + "getEventParticipants/", searchEventParticipants),
    getAhbabManualCount: (eventId) =>
      authAxios.get(url + "getAhbabManualCount", { params: { eventId } }),
    getRufqaAttendanceSummary: (eventId) =>
      authAxios.get(url + "getRufqaAttendanceSummary", { params: { eventId } }),
    saveAhbabManualCount: (eventId, count) =>
      authAxios.post(url + "saveAhbabManualCount", { eventId, count }),
    getResponsibleEventParticipants: (unitId, eventId) =>
      authAxios.get(
        url + "getResponsibleEventParticipants/" + unitId + "/" + eventId
      ),
    getInChargeAndResponsibleEventParticipants: (unitId, eventId) =>
      authAxios.get(
        url +
          "getInChargeAndResponsibleEventParticipants/" +
          unitId +
          "/" +
          eventId
      ),
    canAddEvent: () => authAxios.get(url + "CanAddEvent"),
    getAttendanceAccess: (eventId) =>
      authAxios.get(BASEURL + "eventAttendanceAccess/getList/" + eventId),
    saveAttendanceAccess: (model) =>
      authAxios.post(BASEURL + "eventAttendanceAccess/save/", model),
    removeAttendanceAccess: (id) =>
      authAxios.post(BASEURL + "eventAttendanceAccess/remove/" + id),
    getParticipantsByEvent: (model) =>
      authAxios.post(
        BASEURL + "eventparticipant/GetSelectiveParticipantsByEvent/",
        model
      ),
    searchMembersforEventParticipants: (
      unitId,
      isSubUnit,
      name,
      type,
      eventId
    ) =>
      authAxios.get(
        url +
          "searchMembersforEventParticipants/" +
          unitId +
          "/" +
          isSubUnit +
          "/" +
          name +
          "/" +
          type +
          "/" +
          eventId
      ),
    addeventparticipant: (newRecord) =>
      authAxios.post(
        BASEURL + "eventparticipant/AddEventParticipant/",
        newRecord
      ),
    deleteEventParticipant: (memberId, eventId) =>
      authAxios.delete(
        BASEURL + "eventparticipant/delete/" + memberId + "/" + eventId
      ),
    updateEventParticipant: (record) =>
      authAxios.post(
        BASEURL + "eventparticipant/UpdateSelectiveEventParticipant/",
        record
      ),
    GetEventWiseEventAttendanceReport: (record) =>
      authAxios.post(
        BASEURL + "event/GetEventWiseEventAttendanceReport/",
        record
      ),
    GetEventWiseEventAttendanceExcelReport: (record) =>
      fileAuthAxios.post(
        BASEURL + "event/GetEventWiseEventAttendanceExcelReport/",
        record
      ),
    GetEventWiseEventAttendancePdfReport: (record) =>
      fileAuthAxios.post(
        BASEURL + "event/GetEventWiseEventAttendancePdfReport/",
        record
      ),
    GetRafiqWiseEventAttendanceReport: (record) =>
      authAxios.post(
        BASEURL + "event/GetRafiqWiseEventAttendanceReport/",
        record
      ),
    GetRafiqWiseEventAttendanceExcelReport: (record) =>
      fileAuthAxios.post(
        BASEURL + "event/GetRafiqWiseEventAttendanceExcelReport/",
        record
      ),
    GetRafiqWiseEventAttendancePdfReport: (record) =>
      fileAuthAxios.post(
        BASEURL + "event/GetRafiqWiseEventAttendancePdfReport/",
        record
      ),
    GetUnitWiseEventAttendanceReport: (record) =>
      authAxios.post(
        BASEURL + "event/GetUnitWiseEventAttendanceReport/",
        record
      ),
    GetUnitWiseEventAttendanceExcelReport: (record) =>
      fileAuthAxios.post(
        BASEURL + "event/GetUnitWiseEventAttendanceExcelReport/",
        record
      ),
    GetUnitWiseEventAttendancePdfReport: (record) =>
      fileAuthAxios.post(
        BASEURL + "event/GetUnitWiseEventAttendancePdfReport/",
        record
      ),
    GetEventAttendanceParticipantsReport: (record) =>
      authAxios.post(
        BASEURL + "eventparticipant/GetEventAttendanceParticipantsReport/",
        record
      ),
    GetEventAttendanceReportSummary: (record) =>
      authAxios.post(
        BASEURL + "eventparticipant/GetEventAttendanceReportSummary/",
        record
      ),

    GetEventAttendanceParticipantsExcelReport: (record) =>
      fileAuthAxios.post(
        BASEURL + "eventparticipant/GetEventAttendanceParticipantsExcelReport/",
        record
      ),

    GetEventAttendanceReportSummaryExcel: (record) =>
      fileAuthAxios.post(
        BASEURL + "eventparticipant/GetEventAttendanceReportSummaryExcel/",
        record
      ),

    GetEventAttendanceReportSummaryPdf: (record) =>
      fileAuthAxios.post(
        BASEURL + "eventparticipant/GetEventAttendanceReportSummaryPdf/",
        record
      ),
  };
}
